/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_charity$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartDonationCampaignContainer_app$ref: FragmentReference;
export type HeartDonationCampaignContainer_app = {|
  +charity: ?{|
    +id: string,
    +name: ?string,
    +vcReceived: ?number,
    +$fragmentRefs: DonateHeartsControlsContainer_charity$ref,
  |},
  +$refType: HeartDonationCampaignContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HeartDonationCampaignContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "startTime",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "endTime",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "charityId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "charity",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "charityId",
          "variableName": "charityId",
          "type": "String!"
        }
      ],
      "concreteType": "Charity",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "vcReceived",
          "args": [
            {
              "kind": "Variable",
              "name": "endTime",
              "variableName": "endTime",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "startTime",
              "variableName": "startTime",
              "type": "String"
            }
          ],
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "DonateHeartsControlsContainer_charity",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '633bc8aa6fc32418057c1c824115c69c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Campaign/__generated__/HeartDonationCampaignContainer_app.graphql.js